var firstLocale = 'en-us';
var locales = [
    {
        language: 'ar',
        region: 'ae',
        name: 'العربية - دول الخليج'
    },
    {
        language: 'ar',
        region: 'eg',
        name: 'العربية - مصر'
    },
    {
        language: 'ar',
        region: 'iq',
        name: 'العربية - العراق'
    },
    {
        language: 'ar',
        region: 'ly',
        name: 'العربية - ليبيا'
    },
    {
        language: 'ar',
        region: 'sa',
        name: 'العربية - المملكة العربية السعودية'
    },
    {
        language: 'bg',
        region: 'bg',
        name: 'Български - България'
    },
    {
        language: 'cs',
        region: 'cz',
        name: 'Čeština - Česká Republika'
    },
    {
        language: 'da',
        region: 'dk',
        name: 'Dansk - Danmark'
    },
    {
        language: 'de',
        region: 'at',
        name: 'Deutsch - Österreich'
    },
    {
        language: 'de',
        region: 'ch',
        name: 'Deutsch - Schweiz'
    },
    {
        language: 'de',
        region: 'de',
        name: 'Deutsch - Deutschland'
    },
    {
        language: 'de',
        region: 'lu',
        name: 'Deutsch - Luxemburg'
    },
    {
        language: 'el',
        region: 'gr',
        name: 'Ελληνικά - Ελλάδα'
    },
    {
        language: 'en',
        region: 'ae',
        name: 'English - Gulf'
    },
    {
        language: 'en',
        region: 'au',
        name: 'English - Australia'
    },
    {
        language: 'en',
        region: 'ca',
        name: 'English - Canada'
    },
    {
        language: 'en',
        region: 'cy',
        name: 'English - Cyprus'
    },
    {
        language: 'en',
        region: 'eg',
        name: 'English - Egypt'
    },
    {
        language: 'en',
        region: 'gb',
        name: 'English - United Kingdom'
    },
    {
        language: 'en',
        region: 'hk',
        name: 'English - Hong Kong SAR'
    },
    {
        language: 'en',
        region: 'ie',
        name: 'English - Ireland'
    },
    {
        language: 'en',
        region: 'il',
        name: 'English - Israel'
    },
    {
        language: 'en',
        region: 'in',
        name: 'English - India'
    },
    {
        language: 'en',
        region: 'jo',
        name: 'English - Jordan'
    },
    {
        language: 'en',
        region: 'lb',
        name: 'English - Lebanon'
    },
    {
        language: 'en',
        region: 'lk',
        name: 'English - Sri Lanka'
    },
    {
        language: 'en',
        region: 'mt',
        name: 'English - Malta'
    },
    {
        language: 'en',
        region: 'my',
        name: 'English - Malaysia'
    },
    {
        language: 'en',
        region: 'ng',
        name: 'English - Nigeria'
    },
    {
        language: 'en',
        region: 'nz',
        name: 'English - New Zealand'
    },
    {
        language: 'en',
        region: 'ph',
        name: 'English - Philippines'
    },
    {
        language: 'en',
        region: 'pk',
        name: 'English - Pakistan'
    },
    {
        language: 'en',
        region: 'sa',
        name: 'English - Saudi Arabia'
    },
    {
        language: 'en',
        region: 'sg',
        name: 'English - Singapore'
    },
    {
        language: 'en',
        region: 'us',
        name: 'English - United States'
    },
    {
        language: 'en',
        region: 'za',
        name: 'English - South Africa'
    },
    {
        language: 'es',
        region: 'ar',
        name: 'Español - Argentina'
    },
    {
        language: 'es',
        region: 'bo',
        name: 'Español - Bolivia'
    },
    {
        language: 'es',
        region: 'cl',
        name: 'Español - Chile'
    },
    {
        language: 'es',
        region: 'co',
        name: 'Español - Colombia'
    },
    {
        language: 'es',
        region: 'cr',
        name: 'Español - Costa Rica'
    },
    {
        language: 'es',
        region: 'do',
        name: 'Español - República Dominicana'
    },
    {
        language: 'es',
        region: 'ec',
        name: 'Español - Ecuador'
    },
    {
        language: 'es',
        region: 'es',
        name: 'Español - España'
    },
    {
        language: 'es',
        region: 'gt',
        name: 'Español - Guatemala'
    },
    {
        language: 'es',
        region: 'hn',
        name: 'Español - Honduras'
    },
    {
        language: 'es',
        region: 'mx',
        name: 'Español - México'
    },
    {
        language: 'es',
        region: 'ni',
        name: 'Español - Nicaragua'
    },
    {
        language: 'es',
        region: 'pa',
        name: 'Español - Panamá'
    },
    {
        language: 'es',
        region: 'pe',
        name: 'Español - Perú'
    },
    {
        language: 'es',
        region: 'pr',
        name: 'Español - Puerto Rico'
    },
    {
        language: 'es',
        region: 'py',
        name: 'Español - Paraguay'
    },
    {
        language: 'es',
        region: 'sv',
        name: 'Español - El Salvador'
    },
    {
        language: 'es',
        region: 'uy',
        name: 'Español - Uruguay'
    },
    {
        language: 'es',
        region: 've',
        name: 'Español - Venezuela'
    },
    {
        language: 'et',
        region: 'ee',
        name: 'Eesti - Eesti'
    },
    {
        language: 'fi',
        region: 'fi',
        name: 'Suomi - Suomi'
    },
    {
        language: 'fr',
        region: 'be',
        name: 'Français - Belgique'
    },
    {
        language: 'fr',
        region: 'ca',
        name: 'Français - Canada'
    },
    {
        language: 'fr',
        region: 'ch',
        name: 'Français - Suisse'
    },
    {
        language: 'fr',
        region: 'dz',
        name: 'Français - Algeria'
    },
    {
        language: 'fr',
        region: 'fr',
        name: 'Français - France'
    },
    {
        language: 'fr',
        region: 'lu',
        name: 'Français - Luxembourg'
    },
    {
        language: 'fr',
        region: 'ma',
        name: 'Français - Morocco'
    },
    {
        language: 'fr',
        region: 'tn',
        name: 'Français - Tunisia'
    },
    {
        language: 'he',
        region: 'il',
        name: 'עברית - ישראל'
    },
    {
        language: 'hr',
        region: 'hr',
        name: 'Hrvatski - Hrvatska'
    },
    {
        language: 'hu',
        region: 'hu',
        name: 'Magyar - Magyarország'
    },
    {
        language: 'id',
        region: 'id',
        name: 'Bahasa Indonesia - Indonesia'
    },
    {
        language: 'it',
        region: 'it',
        name: 'Italiano - Italia'
    },
    {
        language: 'ja',
        region: 'jp',
        name: '日本語 - 日本'
    },
    {
        language: 'ko',
        region: 'kr',
        name: '한국어 - 대한민국'
    },
    {
        language: 'lt',
        region: 'lt',
        name: 'Lietuvių - Lietuva'
    },
    {
        language: 'lv',
        region: 'lv',
        name: 'Latviešu - Latvija'
    },
    {
        language: 'nb',
        region: 'no',
        name: 'Bokmål - Norge'
    },
    {
        language: 'nl',
        region: 'be',
        name: 'Nederlands - België'
    },
    {
        language: 'nl',
        region: 'nl',
        name: 'Nederlands - Nederland'
    },
    {
        language: 'pl',
        region: 'pl',
        name: 'Polski - Polska'
    },
    {
        language: 'pt',
        region: 'br',
        name: 'Português - Brasil'
    },
    {
        language: 'pt',
        region: 'pt',
        name: 'Português - Portugal'
    },
    {
        language: 'ro',
        region: 'md',
        name: 'Română - Republica Moldova'
    },
    {
        language: 'ro',
        region: 'ro',
        name: 'Română - România'
    },
    {
        language: 'ru',
        region: 'by',
        name: 'Беларуская - Беларусь'
    },
    {
        language: 'ru',
        region: 'kz',
        name: 'Русский - Казахстан'
    },
    {
        language: 'ru',
        region: 'ru',
        name: 'Русский - Россия'
    },
    {
        language: 'sk',
        region: 'sk',
        name: 'Slovenčina - Slovensko'
    },
    {
        language: 'sl',
        region: 'si',
        name: 'Slovenščina - Slovenija'
    },
    {
        language: 'sr-latn',
        region: 'me',
        name: 'Srpski - Crna Gora'
    },
    {
        language: 'sr-latn',
        region: 'rs',
        name: 'Srpski - Srbija'
    },
    {
        language: 'sv',
        region: 'se',
        name: 'Svenska - Sverige'
    },
    {
        language: 'th',
        region: 'th',
        name: 'ไทย - ไทย'
    },
    {
        language: 'tr',
        region: 'tr',
        name: 'Türkçe - Türkiye'
    },
    {
        language: 'uk',
        region: 'ua',
        name: 'Українська - Україна'
    },
    {
        language: 'vi',
        region: 'vn',
        name: 'Tiếng việt - Việt Nam'
    },
    {
        language: 'zh',
        region: 'cn',
        name: '简体中文(中国大陆)'
    }
].map(function(param) {
    var language = param.language, region = param.region, name = param.name;
    return {
        name: name,
        language: language,
        region: region,
        locale: "".concat(language, "-").concat(region)
    };
}).sort(function(a, b) {
    if (a.locale === firstLocale) return -1;
    if (b.locale === firstLocale) return 1;
    return a.name > b.name ? 1 : -1;
});

export { locales };
